export default __webpack_public_path__ + "static/media/sector_1w.7c7c4ce9.jpg";